// extracted by mini-css-extract-plugin
export default {"radioWrapper":"yesNot_radioWrapper__iZ6F8","radioTitle":"yesNot_radioTitle__gTXw5","radioList":"yesNot_radioList__xSmEo","radioItem":"yesNot_radioItem__VT2Gj"};